module.exports = __webpack_public_path__ + "img/ltksalealert-3x.6635aa3.jpg";